module.exports = __webpack_public_path__ + "static/6b8c60d7b6b61a5cce531e6acba3124e67730f970e654174f362d65040f026b3-6b26eed998d4f29c9bd872f756857bdf.png";